/* esm.sh - rxjs@7.8.2/dist/esm/internal/observable/timer */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/observable/timer.mjs";
